"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = Tag;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Container = _styledComponents.default.span`
  align-items: center;
  background-color: ${p => p.theme.colors[p.backgroundColor]};
  border-radius: ${p => (0, _polished.rem)(p.theme.radii[0])};
  color: ${p => p.theme.colors.white};
  display: inline-flex;
  font-size: ${p => (0, _polished.rem)(p.theme.fontSizes[2])};
  font-weight: 500;
  line-height: 1;
  justify-content: center;
  padding: ${p => (0, _polished.rem)(p.theme.spacing[0])} ${p => (0, _polished.rem)(p.theme.spacing[1])};

  ${p => p.tagSize === 'small' && (0, _styledComponents.css)`
      font-size: ${p => (0, _polished.rem)(p.theme.fontSizes[1])};
      font-weight: 600;
      padding: ${p => (0, _polished.rem)(p.theme.spacing[0])};
    `}
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
function Tag({
  children,
  color = 'deepSkyBlue',
  size = 'medium',
  testId
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    backgroundColor: color,
    "data-testid": testId,
    tagSize: size
  }, children);
}